module.exports = __webpack_public_path__ + "img/no-bike.ac9a18a8.jpg";